<template>
  <div v-if="settings">
    <v-layout align-center wrap>
      <v-flex xs2 class="text-xs-right">
        <span class="title">Event Name:</span>
      </v-flex>
      <v-flex xs5 offset-xs1>
        <content-field
          label="Example: Londonsummit 2020"
          v-model="settings.eventName"
        ></content-field>
      </v-flex>
    </v-layout>

    <v-layout align-center wrap>
      <v-flex xs2 class="text-xs-right">
        <span class="title">Event URL:</span>
      </v-flex>
      <v-flex xs5 offset-xs1>
        <content-field
          label="Example: https://ifxexpo.com/cyprus2020"
          v-model="settings.eventUrl"
        ></content-field>
      </v-flex>
    </v-layout>

    <export-badges />

    <v-layout align-center wrap>
      <v-flex xs2 class="text-xs-right">
        <span class="title">  Forward attendees' emails to admin (BCC):  </span>
      </v-flex>
      <v-flex xs5 offset-xs1>
        <content-field
          label="Email"
          v-model="settings.adminCopyEmail"
          @input="$v.settings.adminCopyEmail.$touch"
          @blur="$v.settings.adminCopyEmail.$touch"
          :error="$v.settings.adminCopyEmail"
        ></content-field>
      </v-flex>
    </v-layout>
    <v-layout align-center wrap>
      <v-flex xs2 class="text-xs-right">
        <span class="title">  Email :  </span>
      </v-flex>
      <v-flex xs5 offset-xs1>
        <content-field
          label="Display Name"
          v-model="settings.notificationsEmail"
          @input="$v.settings.notificationsEmail.$touch"
          @blur="$v.settings.notificationsEmail.$touch"
          :error="$v.settings.notificationsEmail"
        ></content-field>
      </v-flex>
    </v-layout>
    <v-layout align-center wrap>
      <v-flex xs2 class="text-xs-right">
        <span class="title">Google Analytics:</span>
      </v-flex>
      <v-flex xs5 offset-xs1>
        <content-field
          label="Google Analytics ID"
          v-model="settings.googleAnalyticsCodeString"
        ></content-field>
      </v-flex>
    </v-layout>
    <v-layout wrap row>
      <v-flex xs2 class="text-xs-right">
        <span class="title">  Settings :  </span>
      </v-flex>
      <v-flex xs5 offset-xs1>
        <v-checkbox label="Registration enabled" v-model="settings.registrationIsEnabled"/>
      </v-flex>
      <v-flex xs5 offset-xs3>
        <v-checkbox label="Vip registration enabled" v-model="settings.vipRegistrationIsEnabled"/>
      </v-flex>
    </v-layout>
    <v-layout wrap row>
      <v-flex xs5 offset-xs3>
        <v-checkbox label="Disabled photo upload by attendee" v-model="settings.attendeePhotoIsDisabled"/>
      </v-flex>
    </v-layout>
    <v-layout wrap row>
      <v-flex xs5 offset-xs3>
        <v-checkbox label="Killer feature enabled" v-model="settings.killerFeatureIsEnabled"/>
      </v-flex>
    </v-layout>
    <v-layout wrap row>
      <v-flex xs5 offset-xs3>
        <v-checkbox label="Envelope for buy enabled" v-model="settings.envelopeForBuyIsEnabled"/>
      </v-flex>
    </v-layout>
    <v-layout wrap row>
      <v-flex xs5 offset-xs3>
        <v-checkbox label="Envelope for sell enabled" v-model="settings.envelopeForSellIsEnabled"/>
      </v-flex>
    </v-layout>
    <v-layout wrap row>
      <v-flex xs5 offset-xs3>
        <v-checkbox label="Enable floor plan" v-model="settings.floorPlanEnabled"/>
      </v-flex>
    </v-layout>
    <v-layout wrap row>
      <v-flex xs5 offset-xs3>
        <v-checkbox label="Enabled Vat Id validation" v-model="settings.vatIdValidationEnabled"/>
      </v-flex>
    </v-layout>
    <v-layout wrap row>
      <v-flex xs2 class="text-xs-right">
        <span class="title">Lists:  </span>
      </v-flex>
      <v-flex xs2 offset-xs1 v-if="settings.mailChimpSettings">
        <v-select
          v-model="settings.mailChimpSettings.eventsInfoListId "
          :items="getNewsList"
          item-text="name"
          item-value="id"
          label="Events list email"
        />
      </v-flex>
      <v-flex xs2 offset-xs1>
        <v-select
          v-model="settings.mailChimpSettings.newsletterListId"
          :items="getNewsList"
          item-text="name"
          item-value="id"
          label="Newsletter list email"
          @change="receiveSegmentsLists"
        />
      </v-flex>
    </v-layout>
    <v-layout wrap row v-if="settings.mailChimpSettings">
      <v-flex xs2 class="text-xs-right">
        <span class="title"> Newsletter list segments:  </span>
      </v-flex>
      <v-flex xs2 offset-xs1>
        <v-select
          v-model="settings.mailChimpSettings.providersOffersId "
          :items="getSegmentsList"
          item-text="name"
          item-value="id"
          label="Providers offers email"
        />
      </v-flex>
      <v-flex xs2 offset-xs1>
        <v-select
          v-model="settings.mailChimpSettings.dailyNewsId"
          :items="getSegmentsList"
          item-text="name"
          item-value="id"
          label="Daily newsletter email"
        />
      </v-flex>
    </v-layout>
    <v-layout wrap row>
      <v-flex xs3 offset-xs3>
        <content-field
          type="number"
          label="Max length of killer feature message"
          :error="$v.settings.killerFeatureMessageMaxLength"
          v-model="settings.killerFeatureMessageMaxLength"
          @input="$v.settings.killerFeatureMessageMaxLength.$touch"
          @blur="$v.settings.killerFeatureMessageMaxLength.$touch"
        />
      </v-flex>
      <v-flex xs3 offset-xs1>
        <v-select
          v-model="settings.attendeePageStatus"
          :items="attendeePageStatuses"
          label="Attendee page status"
        />
      </v-flex>
    </v-layout>
    <v-layout wrap row>
      <v-flex xs5 offset-xs3 d-flex align-center justify-start>
        <span>Upload file with last year attendees:</span>
        <a-upload
          :url="uploadUrl"
          :extensions="['.csv', '.xlsx']"
          :disabled="!isWriteAvailable"
        />
      </v-flex>
    </v-layout>
    <v-layout wrap row>
      <v-flex xs2 class="text-xs-right">
        <span class="title">Accountants emails :</span>
      </v-flex>
      <v-flex offset-xs1 xs5>
        <e-content-fields
          type="email"
          errorMessage="Accountants emails must be valid emails"
          :inputsValues="settings.accountantsEmails"
          :isError="$v.settings.accountantsEmails.$invalid"
          @input="setAccountantsEmails"
        />
      </v-flex>
    </v-layout>
    <v-layout wrap row>
      <v-flex xs2 class="text-xs-right">
        <span class="title">Contact us receivers emails:</span>
      </v-flex>
      <v-flex offset-xs1 xs5>
        <e-content-fields
          type="email"
          errorMessage="Contact us receivers emails must be valid emails"
          :inputsValues="settings.contactUsReceiversEmails"
          :isError="$v.settings.contactUsReceiversEmails.$invalid"
          @input="setReceiversEmails"
        />
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex xs2 offset-xs3>
        <v-btn
          dark
          color="green"
          @click="update"
          :disabled="!isWriteAvailable"
        >
          Submit
        </v-btn>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import { required, email, numeric, minValue } from 'vuelidate/lib/validators'
  import { clone, path, pathOr } from 'ramda'
  import AUpload from '@/components/shared/Upload'
  import EContentFields from '@/components/shared/EContentFields'
  import mixins from '@/utils/mixins'
  import { api } from '@/modules/api'
  import ExportBadges from './ExportBadges'

  export default {
    name: 'emailNotification',
    components: {
      AUpload,
      ExportBadges,
      EContentFields
    },
    mixins: [mixins.isWriteAvailable, mixins.emailTemplates],
    data () {
      return {
        attendeePageStatuses: [
          'Live', 'Draft'
        ],
        uploadUrl: api.invitationMultiply.getMultiplyUploadAttendeeLink(),
        settings: null,
        segmentsList: null,
        // DON'T DELETE! need for isWriteAvailable mixin
        scopeForWrite: 'registration:write'
      }
    },
    validations () {
      return {
        settings: {
          notificationsEmail: {
            // required,
            email
          },
          adminCopyEmail: {
            // required,
            email
          },
          killerFeatureMessageMaxLength: {
            // required,
            numeric,
            minValue: minValue(0)
          },
          accountantsEmails: {
            // required,
            $each: {
              email,
              // required
            }
          },
          contactUsReceiversEmails: {
            // required,
              $each: {
              email,
              // required
            }
          },
          // googleAnalyticsCodeString: { required }
        }
      }
    },
    computed: {
      ...mapGetters([
        'getSettings',
        'getNewsList',
        'getSegmentsList'
      ])
    },
    watch: {
      getSegmentsList: {
        handler (newVal) {
          if (!newVal.length) return
          this.segmentsList = clone(pathOr([], ['getSegmentsList'], this))
        },
        deep: true
      }
    },
    methods: {
      ...mapActions([
        'updateGeneralSettings',
        'editRegularAttendeeSettings',
        'fetchGeneralSettings',
        'uploadLastYearAttendees',
        'fetchNewsList',
        'editNewsList',
        'fetchSegmentsList'
      ]),
      update () {
        this.$v.settings.$touch()
        if (this.$v.settings.$invalid) return
        this.updateGeneralSettings(this.settings)
        this.editNewsList(this.settings.mailChimpSettings)
      },
      receiveSegmentsLists(segment) {
        this.fetchSegmentsList(segment)
      },
      isSettingInvalid (validationItem) {
        return validationItem.$dirty && validationItem.$invalid ? ['This field is required'] : []
      },
      setAccountantsEmails (emails) {
        this.settings.accountantsEmails = emails
      },
      setReceiversEmails (emails) {
        this.settings.contactUsReceiversEmails = emails
      },
      async setSettings () {
        this.settings = clone(path(['globalSetting'], this.getSettings))
        if (!this.settings.contactUsReceiversEmails) {
          this.settings.contactUsReceiversEmails = []
        }
        if (!this.settings.accountantsEmails) {
          this.settings.accountantsEmails = []
        }
        if (!this.settings.googleAnalyticsCodeString) {
          this.settings.googleAnalyticsCodeString = ''
        }
      },
      async receiveRequestedData () {
        await this.fetchGeneralSettings()
        await this.fetchNewsList()
        await this.setSettings()
        await this.fetchSegmentsList(path(['globalSetting', 'mailChimpSettings', 'newsletterListId'], this.getSettings))
      }
    },
    mounted () {
      this.receiveRequestedData()
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/pages/GeneralSettings/GlobalSettings/index.vue